
export default function filterTickets(tickets, type) {
  // const tickets = app.store.all("supportTickets");

  if(type.length === 0) return tickets;

  return tickets.filter(obj => type.indexOf(obj.ticketStatus()) >= 0)
}